import { render } from "./AddLogo.vue?vue&type=template&id=084b3f82&scoped=true"
import script from "./AddLogo.vue?vue&type=script&lang=js"
export * from "./AddLogo.vue?vue&type=script&lang=js"

import "./AddLogo.vue?vue&type=style&index=0&id=084b3f82&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084b3f82"]])

export default __exports__